import React, { useState } from "react";
import { Link45deg } from "react-bootstrap-icons";

export default function ShareThisClub({ cancelModal, urlName }) {
  const [linkCopied, setLinkCopied] = useState(false);
  //styled
  const copyLinkToClipboard = () => {
   const clubLink = `http://membotic.com/${urlName}`;
    navigator.clipboard
      .writeText(clubLink)
      .then(() => setLinkCopied(true))
      .catch((err) => console.error("Failed to copy link: ", err));
  };
  return (
    <div className="send-modal-overlay d-flex justify-content-center align-items-center text-center">
      <div className="send-modal bg-white rounded p-3 position-relative">
        <div className="blueBanner">
          <p className="fw-bold m-2 p-2 fontSize20">Share</p>
        </div>

        <button
          type="button"
          className="close-button"
          onClick={cancelModal}
          aria-label="Close"
        >
          &times;
        </button>
        {linkCopied ? (
          <div className="pointer" onClick={copyLinkToClipboard}>
            <Link45deg className="link-icon-success" />
            <p className="text-success">Link Copied</p>
          </div>
        ) : (
          <div className="pointer" onClick={copyLinkToClipboard}>
            <Link45deg className="link-icon" />
            <p className="text-muted">Copy Link</p>
          </div>
        )}

        <div className="send-modal-footer"></div>
      </div>
    </div>
  );
}
